/**
 * Sold-out option values from Shopify inventory (available == false OR inventory_quantity <= 0).
 * No hardcoded SKUs. PDP + landing: strikethrough UI and block selection.
 */
(function () {
  function isVariantSoldOut(variant) {
    if (!variant) return false;
    // Match Shopify storefront `available` (same as PDP /products/{handle}.js).
    // Do not use inventory_quantity: Liquid JSON includes qty 0 while `available` can
    // still be true (continue selling), which made landing look sold out vs PDP.
    return variant.available === false;
  }

  /**
   * @param {any} product
   */
  function applyToProduct(product) {
    if (!product || !Array.isArray(product.variants)) return product;
    product.variants.forEach(function (variant) {
      if (isVariantSoldOut(variant)) {
        variant.available = false;
      }
    });
    return product;
  }

  function productOptionNames(product) {
    if (!product || !product.options) return [];
    return product.options.map(function (o) {
      return typeof o === 'string' ? o : ((o && o.name) || '');
    });
  }

  function variantOptionValues(variant) {
    if (!variant) return [];
    if (variant.options && variant.options.length) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter(function (x) {
      return x != null && x !== '';
    });
  }

  function optionValuesMatch(a, b) {
    if (a === b) return true;
    return String(a || '').toLowerCase().trim() === String(b || '').toLowerCase().trim();
  }

  /**
   * @param {string} optionName
   * @param {string} optionValue
   * @param {any} product
   * @param {Record<string, string>} selectedOptions
   */
  function isOptionValueStockout(optionName, optionValue, product, selectedOptions) {
    if (!product || !Array.isArray(product.variants)) return false;
    var names = productOptionNames(product);
    if (!names.length) return false;

    var next = Object.assign({}, selectedOptions || {});
    next[optionName] = optionValue;

    var optionsArray = names.map(function (name) {
      return next[name];
    });

    if (optionsArray.some(function (v) { return v == null || v === ''; })) {
      var optIndex = -1;
      var n = String(optionName || '').toLowerCase();
      for (var i = 0; i < names.length; i++) {
        if (String(names[i]).toLowerCase() === n) {
          optIndex = i;
          break;
        }
      }
      if (optIndex < 0) return false;
      var matching = product.variants.filter(function (variant) {
        var vals = variantOptionValues(variant);
        return vals[optIndex] != null && optionValuesMatch(vals[optIndex], optionValue);
      });
      if (!matching.length) return false;
      return matching.every(function (variant) {
        return isVariantSoldOut(variant);
      });
    }

    var variant = product.variants.find(function (v) {
      var vals = variantOptionValues(v);
      if (!vals.length) return false;
      return vals.every(function (opt, idx) {
        return optionValuesMatch(opt, optionsArray[idx]);
      });
    });
    return isVariantSoldOut(variant);
  }

  function ensureStrikeSvg(label) {
    if (!(label instanceof HTMLElement)) return;
    if (label.querySelector('svg')) return;
    var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    svg.setAttribute('width', '100%');
    svg.setAttribute('height', '100%');
    svg.setAttribute('viewBox', '0 0 100 46');
    svg.setAttribute('preserveAspectRatio', 'xMidYMid slice');
    svg.setAttribute('aria-hidden', 'true');
    svg.setAttribute('focusable', 'false');
    var line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('x1', '100');
    line.setAttribute('y1', '0');
    line.setAttribute('x2', '0');
    line.setAttribute('y2', '46');
    line.setAttribute('vector-effect', 'non-scaling-stroke');
    svg.appendChild(line);
    label.appendChild(svg);
  }

  function isSoldOutInput(input) {
    if (!(input instanceof HTMLInputElement)) return false;
    return (
      input.disabled ||
      input.getAttribute('data-option-available') === 'false' ||
      input.dataset.stockout === 'true'
    );
  }

  function markInputUnavailable(input) {
    if (!(input instanceof HTMLInputElement)) return;
    var label = input.closest('label');
    var already =
      input.disabled &&
      input.getAttribute('data-option-available') === 'false' &&
      input.dataset.stockout === 'true' &&
      (!label || label.classList.contains('variant-option--stockout'));

    if (!already) {
      input.disabled = true;
      input.setAttribute('aria-disabled', 'true');
      input.dataset.optionAvailable = 'false';
      input.dataset.stockout = 'true';
    }

    if (input.checked) {
      input.checked = false;
      var fieldset = input.closest('fieldset');
      if (fieldset) {
        fieldset.classList.remove('size-selected');
        var legend = fieldset.querySelector('.variant-option__swatch-value');
        if (legend && fieldset.classList.contains('type-Size')) {
          legend.textContent = 'Select size';
        }
      }
    }
    if (label) {
      label.classList.add('variant-option--stockout');
      label.classList.remove('size-swatch-label-active');
      label.setAttribute('aria-disabled', 'true');
      ensureStrikeSvg(label);
    }
  }

  function clearInputUnavailable(input) {
    if (!(input instanceof HTMLInputElement)) return;
    var label = input.closest('label');
    var needsClear =
      input.disabled ||
      input.getAttribute('data-option-available') === 'false' ||
      input.dataset.stockout === 'true' ||
      (label && label.classList.contains('variant-option--stockout'));

    if (!needsClear) return;

    input.disabled = false;
    input.removeAttribute('aria-disabled');
    input.dataset.optionAvailable = 'true';
    delete input.dataset.stockout;
    if (label) {
      label.classList.remove('variant-option--stockout');
      label.removeAttribute('aria-disabled');
      var svg = label.querySelector(':scope > svg');
      if (svg) svg.remove();
    }
  }

  function readSoldOutVariantsFromPicker(picker) {
    var script =
      (picker && picker.querySelector('script[data-wh-soldout-variants]')) ||
      (picker && picker.querySelector('script[data-wh-stockout-variants]'));
    if (!script) return [];
    try {
      var data = JSON.parse(script.textContent || '[]');
      return Array.isArray(data) ? data : [];
    } catch (_) {
      return [];
    }
  }

  function getSelectedOptionsFromPicker(picker) {
    var selected = {};
    if (!picker) return selected;
    picker.querySelectorAll('fieldset.variant-option').forEach(function (fieldset) {
      // Pack Style is a fake option — not part of product.variants
      if (fieldset.querySelector('input[data-wildhawk-pack-style]')) return;
      var checked = fieldset.querySelector('input[type="radio"]:checked');
      if (!(checked instanceof HTMLInputElement)) return;
      var label = checked.closest('label');
      var optionName = (label && label.getAttribute('data-size')) || '';
      if (optionName && checked.value) selected[optionName] = checked.value;
    });
    return selected;
  }

  function normalizePackStyleKey(raw) {
    var v = String(raw || '').toLowerCase().trim();
    if (!v) return null;
    if (v.indexOf('boxer') >= 0) return 'boxerBrief';
    if (v.indexOf('brief') >= 0) return 'brief';
    return null;
  }

  /**
   * On Wildhawk/Freewill style-split PDPs, Style switches between different catalog
   * products without remounting Size buttons. Liquid OOS marks belong to the page
   * product only — recompute Size availability from the active pack catalog entry.
   */
  function getActivePackCatalogProduct() {
    var catalog = window.wildhawkPackCatalog;
    if (!catalog) return null;

    var packBtn = document.querySelector('.pack-btn[data-pack-key].active');
    var packKey = packBtn && packBtn.dataset ? packBtn.dataset.packKey : null;
    if (!packKey) return null;

    var styleInput = document.querySelector('input[data-wildhawk-pack-style]:checked');
    var styleKey = styleInput ? normalizePackStyleKey(styleInput.value) : null;
    if (styleKey && catalog[packKey + '__' + styleKey]) {
      return catalog[packKey + '__' + styleKey];
    }
    return catalog[packKey] || null;
  }

  function findPackVariantForSize(product, selected, sizeValue) {
    if (!product || !Array.isArray(product.variants)) return null;
    var options = product.options || [];

    for (var i = 0; i < product.variants.length; i++) {
      var variant = product.variants[i];
      if (!variant) continue;
      var ok = true;

      for (var oi = 0; oi < options.length; oi++) {
        var opt = options[oi];
        var name = opt && opt.name ? opt.name : '';
        if (!name) continue;
        if (/^style$/i.test(name)) continue;

        var variantVal =
          variant.optionByName && variant.optionByName[name] != null
            ? String(variant.optionByName[name])
            : '';

        if (/^size$/i.test(name)) {
          if (variantVal !== String(sizeValue)) {
            ok = false;
            break;
          }
          continue;
        }

        var selectedVal = selected[name];
        if (selectedVal == null || selectedVal === '') continue;
        if (variantVal !== String(selectedVal)) {
          ok = false;
          break;
        }
      }

      if (ok) return variant;
    }
    return null;
  }

  function clearSizeFieldsetSelection(sizeFieldset) {
    if (!sizeFieldset) return;
    sizeFieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
      if (input instanceof HTMLInputElement) input.checked = false;
    });
    sizeFieldset.classList.remove('size-selected');
    sizeFieldset.querySelectorAll('label.size-swatch-label').forEach(function (label) {
      label.classList.remove('size-swatch-label-active');
    });
    var legend = sizeFieldset.querySelector('.variant-option__swatch-value');
    if (legend) legend.textContent = 'Select size';
  }

  function applyPackCatalogSoldOut(picker) {
    var product = getActivePackCatalogProduct();
    if (!product || !Array.isArray(product.variants)) return false;

    var sizeFieldset = picker.querySelector('fieldset.type-Size');
    if (!sizeFieldset) return false;

    // Snapshot selection without Size — Size is the option we are evaluating.
    var selected = getSelectedOptionsFromPicker(picker);
    delete selected.Size;

    var checkedBecameUnavailable = false;

    sizeFieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
      if (!(input instanceof HTMLInputElement)) return;

      var match = findPackVariantForSize(product, selected, input.value);
      // No matching variant for this style/color = unavailable on this product.
      var shouldSoldOut = !match || isVariantSoldOut(match);
      if (shouldSoldOut) {
        if (input.checked) checkedBecameUnavailable = true;
        markInputUnavailable(input);
      } else {
        clearInputUnavailable(input);
      }
    });

    if (checkedBecameUnavailable) {
      clearSizeFieldsetSelection(sizeFieldset);
      picker.dispatchEvent(
        new CustomEvent('wildhawk:size-unavailable', { bubbles: true })
      );
      if (typeof window.wildhawkPackEnsureAtcDisabledIfNoSize === 'function') {
        window.wildhawkPackEnsureAtcDisabledIfNoSize();
      }
    }

    return true;
  }

  function applyLiquidSoldOut(picker) {
    var soldOutVariants = readSoldOutVariantsFromPicker(picker);
    var selected = getSelectedOptionsFromPicker(picker);
    var sizeFieldset = picker.querySelector('fieldset.type-Size');

    soldOutVariants.forEach(function (variant) {
      if (!variant || !Array.isArray(variant.options) || !variant.options.length) return;

      var selectedValues = Object.keys(selected).map(function (k) {
        return String(selected[k]);
      });
      var selectedNonSize = selectedValues.filter(function (val) {
        if (!sizeFieldset) return true;
        var sizeInput = sizeFieldset.querySelector(
          'input[type="radio"][value="' + val.replace(/"/g, '\\"') + '"]'
        );
        return !sizeInput;
      });
      var othersMatch = selectedNonSize.every(function (val) {
        return variant.options.map(String).indexOf(val) !== -1;
      });
      if (selectedNonSize.length && !othersMatch) return;

      var sizeVal = String(variant.options[variant.options.length - 1]);
      if (sizeFieldset) {
        sizeFieldset.querySelectorAll('input[type="radio"]').forEach(function (input) {
          if (!(input instanceof HTMLInputElement)) return;
          if (input.value === sizeVal) markInputUnavailable(input);
        });
      }

      if (variant.id != null) {
        picker.querySelectorAll('input[data-variant-id="' + variant.id + '"]').forEach(function (input) {
          if (input instanceof HTMLInputElement) markInputUnavailable(input);
        });
      }
    });

    picker.querySelectorAll('input[data-option-available="false"], input[data-stockout="true"]').forEach(function (input) {
      if (input instanceof HTMLInputElement) markInputUnavailable(input);
    });
  }

  var applyingPdp = false;
  var applyQueued = false;

  function applyToPdpPicker(root) {
    if (applyingPdp) {
      applyQueued = true;
      return;
    }

    var scope = root || document;
    var pickers = scope.querySelectorAll('variant-picker');
    if (!pickers.length) return;

    applyingPdp = true;
    applyQueued = false;

    try {
      var usePackCatalog =
        !!window.wildhawkPackCatalog &&
        !!(window.__WILDHAWK_PACK_STYLE_SPLIT__ || document.querySelector('input[data-wildhawk-pack-style]'));

      pickers.forEach(function (picker) {
        if (usePackCatalog && applyPackCatalogSoldOut(picker)) return;
        applyLiquidSoldOut(picker);
      });
    } finally {
      // Let MutationObserver flush our DOM writes before accepting new applies.
      window.setTimeout(function () {
        applyingPdp = false;
        if (applyQueued) applyToPdpPicker(document);
      }, 0);
    }
  }

  function installSelectionGuards() {
    document.addEventListener(
      'pointerdown',
      function (event) {
        var target = event.target;
        if (!(target instanceof Element)) return;

        var landingBtn = target.closest(
          '.select-two-products__variant-button.is-unavailable, .select-two-products__variant-button.is-stockout'
        );
        if (landingBtn) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        var label = target.closest('label.variant-option__button-label');
        if (!label) return;
        var input = label.querySelector('input[type="radio"]');
        if (isSoldOutInput(input)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      true
    );

    document.addEventListener(
      'click',
      function (event) {
        var target = event.target;
        if (!(target instanceof Element)) return;

        var landingBtn = target.closest(
          '.select-two-products__variant-button.is-unavailable, .select-two-products__variant-button.is-stockout'
        );
        if (landingBtn) {
          event.preventDefault();
          event.stopImmediatePropagation();
          return;
        }

        var label = target.closest('label.variant-option__button-label');
        if (!label) return;
        var input = label.querySelector('input[type="radio"]');
        if (isSoldOutInput(input)) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      },
      true
    );

    document.addEventListener(
      'change',
      function (event) {
        var target = event.target;
        if (!(target instanceof HTMLInputElement) || target.type !== 'radio') return;
        if (!isSoldOutInput(target)) return;
        target.checked = false;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (window.WildhawkStockout) window.WildhawkStockout.applyToPdpPicker(document);
      },
      true
    );
  }

  function schedulePdpApply() {
    applyToPdpPicker(document);
    // One delayed pass after pack catalog / section morph settle — avoid a tight re-apply loop.
    window.setTimeout(function () { applyToPdpPicker(document); }, 400);
  }

  function observePdp() {
    var root = document.querySelector('[data-wildhawk-pack-pdp]') || document.querySelector('variant-picker');
    if (!root || root.dataset.whStockoutObserved === '1') return;
    root.dataset.whStockoutObserved = '1';
    var timer = 0;
    var observer = new MutationObserver(function () {
      if (applyingPdp) return;
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        if (applyingPdp) return;
        applyToPdpPicker(document);
      }, 120);
    });
    // childList only: attribute writes from mark/clear must not re-trigger apply.
    observer.observe(root, { childList: true, subtree: true });
  }

  window.WildhawkStockout = {
    isVariantSoldOut: isVariantSoldOut,
    isVariantStockout: isVariantSoldOut,
    isStockoutSku: function () { return false; },
    isOptionValueStockout: isOptionValueStockout,
    applyToProduct: applyToProduct,
    applyToPdpPicker: applyToPdpPicker,
  };

  function init() {
    installSelectionGuards();
    schedulePdpApply();
    observePdp();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
